import type { RouteRecordRaw } from 'vue-router'

export const DashboardPage = {
  dashboard: 'Dashboard',
}

export const Dashboard: RouteRecordRaw = {
  path: '/dashboard',
  name: DashboardPage.dashboard,
  component: () => import('@/pages/main/Dashboard/DashboardPage.vue'),
  meta: { title: 'Dashboard', requiresAuth: true },
}
